import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { MessageModal } from '../../components/modals/MessageModal';
export function Verify2FAPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || '';
  const [code, setCode] = useState('');
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (code.length !== 6) {
      setIsMessageModalOpen(true);
      return;
    }
    setTimeout(() => {
      navigate('/dashboard');
    }, 1000);
  };
  return <div data-testid="verify-2fa-page" className="min-h-screen bg-[#f5f5f7] font-sans text-[#1f2933]" data-id="element-2329">
      <header data-testid="verify-2fa-header" className="bg-white border-b border-gray-300 py-4 px-6 md:px-12" data-id="element-2330">
        <Link data-testid="verify-2fa-logo-link" to="/" className="flex items-center gap-2" data-id="element-2331">
          <div className="w-8 h-8 bg-[#1f2933] rounded-sm" data-id="element-2332"></div>
          <span className="font-bold text-xl tracking-tight" data-id="element-2333">
            Citiplots.com
          </span>
        </Link>
      </header>

      <main data-testid="verify-2fa-main" className="max-w-md mx-auto px-4 py-12" data-id="element-2334">
        <div data-testid="verify-2fa-card" className="bg-white border border-gray-300 p-8 shadow-sm" data-id="element-2335">
          <h1 data-testid="verify-2fa-title" className="text-2xl font-bold mb-2" data-id="element-2336">
            Two-Factor Authentication
          </h1>
          <p data-testid="verify-2fa-subtitle" className="text-sm text-gray-500 mb-6" data-id="element-2337">
            Enter the 6-digit code from your authenticator app
          </p>

          <form data-testid="verify-2fa-form" onSubmit={handleSubmit} className="space-y-4" data-id="element-2338">
            <div data-id="element-2339">
              <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-2340">
                Authentication Code
              </label>
              <input data-testid="verify-2fa-code-input" type="text" required maxLength={6} value={code} onChange={e => setCode(e.target.value.replace(/\D/g, ''))} placeholder="000000" className="w-full p-2 border border-gray-300 bg-gray-50 text-center text-2xl font-mono tracking-widest focus:outline-none focus:border-gray-500" data-id="element-2341" />
            </div>

            <button data-testid="verify-2fa-submit-btn" type="submit" className="w-full py-3 bg-[#1f2933] text-white font-bold hover:bg-gray-800" data-id="element-2342">
              Verify
            </button>
          </form>

          <p data-testid="verify-2fa-backup-link" className="mt-6 text-center text-xs text-gray-500" data-id="element-2343">
            Lost your device?{' '}
            <Link to="/auth/signin" className="text-blue-600 hover:underline" data-id="element-2344">
              Use backup code
            </Link>
          </p>
        </div>
      </main>

      <MessageModal isOpen={isMessageModalOpen} onClose={() => setIsMessageModalOpen(false)} title="Invalid Code" message="Please enter a valid 6-digit authentication code." type="error" data-id="element-2345" />
    </div>;
}